import type { Meta, StoryFn } from '@storybook/react';
import { useMemo } from 'react';

import { SkipLinks } from '@pega/cosmos-react-core';
import type { SkipLinksProps } from '@pega/cosmos-react-core';

import { StyledSkipLinksWrapper } from './SkipLinks.styles';

export default {
  title: 'Core/SkipLinks',
  component: SkipLinks
} as Meta;

export const SkipLinksDemo: StoryFn<SkipLinksProps> = () => {
  const items: SkipLinksProps['items'] = useMemo(
    () => [
      {
        label: 'go to main content',
        target: {
          ariaLabel: 'main content',
          selector: 'main'
        }
      },
      {
        label: 'go to footer',
        target: {
          ariaLabel: 'footer',
          selector: 'footer'
        }
      }
    ],
    []
  );

  return (
    <StyledSkipLinksWrapper>
      <SkipLinks items={items} />
    </StyledSkipLinksWrapper>
  );
};
